import React, { MouseEventHandler, useState } from "react";
import { Route, Switch, useLocation, useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { loggedUserState } from "../../Store/atoms";
import CreateCodeTable from "../CreateCodeTable";
import Login from "../Login";
import SignUp from "../SignUp";
import TablesDisplay from "../TablesDisplay";
import TableView from "../TableView";
import Favorites from "./Favorites";
import Header from "./Header";
import NavBar from "./NavBar";
import SidePanel from "./SidePanel";

import "./styles.css";

export default () => {
  const loggedUser = useRecoilValue(loggedUserState);

  // if (
  //   localStorage.getItem("userId") === null ||
  //   localStorage.getItem("jwt") === null
  // ) {
  //   localStorage.clear();
  //   return <Login />;
  // }
  // if (loggedUser.id === 0) {
  //   return <Login />;
  // }

  const displayLogin =
    localStorage.getItem("userId") === null ||
    localStorage.getItem("jwt") === null ||
    loggedUser.id === 0;

  return (
    <div id="main" className="main">
      <Switch>
        <Route path="/favorites">
          {!displayLogin && (
            <>
              <NavBar />
              <Favorites />
            </>
          )}
          {displayLogin && <Login />}
        </Route>
        <Route path="/create-new-table">
          {!displayLogin && (
            <>
              <NavBar />
              <CreateCodeTable />
            </>
          )}
          {displayLogin && <Login />}
        </Route>
        <Route path="/browse-tables">
          {!displayLogin && (
            <>
              <NavBar />
              <TablesDisplay />
            </>
          )}
          {displayLogin && <Login />}
        </Route>
        <Route path="/tables">
          {!displayLogin && (
            <>
              <NavBar />
              <TableView />
            </>
          )}
          {displayLogin && <Login />}
        </Route>
        <Route path="/signup">
          {!displayLogin && (
            <>
              <NavBar />
              <Favorites />
            </>
          )}
          {displayLogin && <SignUp />}
        </Route>
        <Route path="/">
          {!displayLogin && (
            <>
              <NavBar />
              <Favorites />
            </>
          )}
          {displayLogin && <Login />}
        </Route>
      </Switch>
    </div>
  );
};
